import { render, staticRenderFns } from "./AvatarGroupVariant.vue?vue&type=template&id=21b5093d"
import script from "./AvatarGroupVariant.vue?vue&type=script&lang=js"
export * from "./AvatarGroupVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports